import { render, staticRenderFns } from "./ProspectList.vue?vue&type=template&id=791bcaba&scoped=true&"
import script from "./ProspectList.vue?vue&type=script&lang=js&"
export * from "./ProspectList.vue?vue&type=script&lang=js&"
import style0 from "./ProspectList.vue?vue&type=style&index=0&id=791bcaba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791bcaba",
  null
  
)

export default component.exports